import { render, staticRenderFns } from "./IadeArizaDetayButon.vue?vue&type=template&id=6179b218&"
import script from "./IadeArizaDetayButon.vue?vue&type=script&lang=js&"
export * from "./IadeArizaDetayButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports